<div class="col-lg-12 mb-3 parent content-scroll-screen-02">
  <div class="row child">
    <p-card class="card-spacing-0">
      <div class="col-12 m-3">
        <div class="row d-flex align-items-end">
          <ng-container>
            <div class="col-3 fixed-width">
              <div class="form-group has-float-label">
                <label class="form-label" for="bcSelectedId"
                  >Branding Consultant 2<span class="madatory-field"
                    >*</span
                  ></label
                >
                <p-select
                  [(ngModel)]="bcSelectedId"
                  [showClear]="true"
                  [filter]="true"
                  [options]="bcList"
                  optionLabel="firstName"
                  optionValue="personnelNumber"
                  placeholder="Select Branding Consultant">
                  <ng-template let-item pTemplate="item">
                    {{
                      (item?.firstName || "") +
                        " " +
                        (item?.lastName || "") +
                        " " +
                        "(" +
                        item?.personnelNumber +
                        ")"
                    }}
                  </ng-template>
                </p-select>
              </div>
            </div>
          </ng-container>

          <ng-container>
            <div class="col-3 fixed-width">
              <div class="form-group has-float-label">
                <label class="form-label" for="selectedDateRange"
                  >Date Range</label
                >
                <p-select
                  #filter
                  [showClear]="true"
                  [filter]="true"
                  [(ngModel)]="selectedDateRange"
                  [options]="dateRange"
                  optionLabel="name"
                  optionValue="name"
                  placeholder="Select Date Range"
                  (onChange)="onDateRangeSelection($event)">
                  <ng-template let-item pTemplate="item">
                    {{ item.name }}
                  </ng-template>
                </p-select>
              </div>
            </div>
            <div class="col-auto fixed-width">
              <div class="form-group has-float-label">
                <label class="form-label has-float-label d-block" for="fromDate"
                  >From Date</label
                >
                <p-date-picker
                  [disabled]="disabledFromAndToDate"
                  jniAutoCompleteBlocker
                  [(ngModel)]="fromDate"
                  id="fromDate"
                  view="month"
                  dateFormat="mm/yy"
                  [showOnFocus]="false"
                  [showIcon]="true"
                  (onSelect)="onFromDateSelection($event)"></p-date-picker>
              </div>
            </div>
            <div class="col-auto fixed-width">
              <div class="form-group has-float-label">
                <label class="form-label d-block" for="toDate">To Date</label>
                <p-date-picker
                  [disabled]="disabledFromAndToDate"
                  jniAutoCompleteBlocker
                  [(ngModel)]="toDate"
                  id="toDate"
                  view="month"
                  dateFormat="mm/yy"
                  [showOnFocus]="false"
                  [showIcon]="true"
                  (onSelect)="onToDateSelection($event)"></p-date-picker>
              </div>
            </div>
          </ng-container>

          <div class="col-2 fixed-width-button">
            <div class="form-group has-float-label d-flex mt-3">
              <p-button
                label="Filter"
                (onClick)="onSubmit()"
                [disabled]="filterDisabled()" />
            </div>
          </div>
        </div>
      </div>
    </p-card>
  </div>
</div>
